<template>
  <div class="navs l_o_btm">
    <router-link to="/">
      <div class="nav">
        <i class="iconfont icon-shouye "
           :class="{active:sta=='1','icon-shouyeH': sta=='1',}"></i>
        <p>{{$t('footNav_home')}}</p>
      </div>
    </router-link>
    <router-link to="/info" v-if="mhNewsDis">
      <div class="nav">
        <i class="iconfont icon-xiaoxi2"
           :class="{active:sta=='2','icon-xiaoxiH': sta=='2',}"></i>
        <p>{{$t('footNav_info')}}</p>
        <div class="message"
             v-if='infoCount>0'>{{infoCount}}
        </div>
      </div>
    </router-link>
<!--    <router-link to="/discoverList" v-if='!hideAdvertise'>-->
<!--      <div class="nav">-->
<!--        <i class="iconfont"-->
<!--           :class="{active:sta=='3','icon-zhinanzhenfaxiandaohangdizhiweizhi1': sta=='3', 'icon-zhinanzhenfaxiandaohangdizhiweizhi': sta != '3'}"></i>-->
<!--        <p>{{$t('footNav_discover')}}</p>-->
<!--      </div>-->
<!--    </router-link>-->
    <router-link to="/center">
      <div class="nav">
        <i class="iconfont icon-gerenzhongxin"
           :class="{active:sta=='4','icon-gerenzhongxinH': sta=='4'}"></i>
        <p>
          <span>{{$t('footNav_center')}}</span>
        </p>
      </div>
    </router-link>
  </div>
</template>
<script>
  export default {
    props: ["sta"],
    data() {
      return {
        infoCount: 0,
        hideAdvertise: false,
        mhNewsDis: false
      };
    },
    mounted() {
      this.getData();
      this.getGlobalPermission()
      this.getSysoptionResult()
    },
    methods: {
      getGlobalPermission() {
        const self = this
        this.$http.get("/mobilepmsapi/sysOptions/findOptionByOpen").then(res => {
          if (res.data.result == 0) {
            let retVal = res.data.retVal || {};
            this.hideAdvertise = true || !!retVal.hideAdvertise;
            localStorage.setItem('CustomersOpen', retVal.CustomersOpen ? "yes" : 'no') // 客源范围的日期删选
            localStorage.setItem('OrderCountForRoomNumber', retVal.OrderCountForRoomNumber ? "yes" : 'no') // 客源范围的日期删选
            localStorage.setItem('rateChange', retVal.rateChange ? "yes" : 'no') // 判断用户是否是 ADMIN
            localStorage.setItem('isAdmin', retVal.isAdmin ? "yes" : 'no') // 判断用户是否是 ADMIN
            localStorage.setItem('isJingJiang', retVal.isJingJiang ? "yes" : 'no') // 判断用户是否是 ADMIN
            localStorage.setItem('isThefClient', retVal.isThefClient ? "yes" : 'no') // 判断用户是否是 ADMIN
            localStorage.setItem('jjAccountAdjust', retVal.jjAccountAdjust ? "yes" : 'no') // 判断用户是否是 ADMIN
            localStorage.setItem('isHuanQiu', retVal.isHuanQiu ? "yes" : 'no') // 判断用户是否是 ADMIN
            localStorage.setItem('useMhPermission', retVal.useMhPermission ? "yes" : 'no') // 判断用户是否是 ADMIN

            // 新到集团马总特殊要求年份可配置
            localStorage.setItem('isRongTong', retVal.isRongTong ? "yes" : 'no') // 判断酒店是否为融通
            // localStorage.setItem('isRongTong', "yes") // 判断酒店是否为融通

            localStorage.setItem('revenueReportYear', retVal.revenueReportYear) // 营收情况往前倒推的年份 用负数，往前一年就 -1
            localStorage.setItem('revenueCompareYear',  retVal.revenueCompareYear) // 营收对比显示的项数 1-4
            localStorage.setItem('dataDisplayK', retVal.dataDisplayK ? 'yes' : 'no') // 营收对比单位统一为K
            localStorage.setItem('dataDisplayW', retVal.dataDisplayW ? 'yes' : 'no') // 营收对比单位统一为W
            // localStorage.setItem('dataDisplayW', 'yes') // 营收对比单位统一为W
            localStorage.setItem('hotelSelectType', retVal.hotelSelectType ? 'yes' : 'no') // 酒店删选
            localStorage.setItem('showRsvRateDscExamine', retVal.showRsvRateDscExamine ? 'yes' : 'no') // 房价优惠审批

            localStorage.setItem('newUserLoginCheck', retVal.newUserLoginCheck ? 'yes' : 'no') // 房情筛选楼栋
            localStorage.setItem('updateRoomStaForThef', retVal.updateRoomStaForThef ? 'yes' : 'no') // 商务版修改房态加服务员
            localStorage.setItem('hideIndexBarData', retVal.hideIndexBarData ? 'yes' : 'no') //首页隐藏排行榜
            //预订单生成支付二维码控制
            localStorage.setItem('useQrcodePay', retVal.useQrcodePay ? 'yes' : 'no') //房情详情页生成二维码控制
            //营收情况是否含税开关
            localStorage.setItem('revenueReportIsTax', retVal.revenueReportIsTax ? 'yes' : 'no')

            localStorage.setItem('isLcg', retVal.isLcg ? 'yes' : 'no') // 优屋美宿的酒店要支持二级品牌筛选
            localStorage.setItem('showRevenueChart', retVal.showRevenueChart ? 'yes' : 'no') //营收报表图表
            localStorage.setItem('reportInterval', retVal.reportInterval ? 'yes' : 'no') //营收报表区间报表
            localStorage.setItem('showFangQList', retVal.showFangQList ? 'yes' : 'no') // 房情列表
            localStorage.setItem('showFromSource', retVal.showFromSource ? 'yes' : 'no') // 客源情况增加来源
            localStorage.setItem('showEditWeixiuRemark', retVal.showEditWeixiuRemark ? 'yes' : 'no') // 维修房备注追加
            localStorage.setItem('todayCreateOrder', retVal.todayCreateOrder ? 'yes' : 'no') // 维修房备注追加
            localStorage.setItem('isOpenReport1ArgPyear',retVal.isOpenReport1ArgPyear ? true : false) // 是否开启自定义选择年份功能
            localStorage.setItem('openControlPanel',retVal.openControlPanel ? 'yes' : 'no') // 房情列表额外数据
            this.isHuanQiu = retVal.isHuanQiu
            this.mhNewsDis = this.$hasPermission('mh!news!dis', true)
            if (retVal.isHuanQiu) {
              self.$router.replace('/opera/indexHuanQiu')
            }
          }
        });
      },
      getSysoptionResult() {
        this.$http.get("/mobilepmsapi/sysOptions/sysoptionResult", {
          noErrorToast: true
        }).then(res => {
          if (res.data.result == 0) {
            let retVal = res.data.retVal || {};
            localStorage.setItem('hotelCode', retVal.hotelCode)
            localStorage.setItem('hotelGroupId', retVal.hotelGroupId)
            localStorage.setItem('hotelId', retVal.hotelId)
          }
        });
      },

      getData() {
        if (localStorage.getItem("JWT_TOKEN")) {
          this.$http
            .get("/mobilepmsapi/message/unreadMessageNumber")
            .then(res => {
              this.infoCount = res.data.retVal;
              if (this.$isApp) {
                plus.runtime.setBadgeNumber(this.infoCount);
                if (plus.os.name == "iOS") {
                  var GeTuiSdk = plus.ios.importClass("GeTuiSdk");
                  GeTuiSdk.setBadge(this.infoCount);
                }
              }
            });
        }
      }
    }
  };
</script>
<style lang='less' scoped>
  .navs {
    box-shadow: 0 -0.0533rem 0.5333rem rgba(0, 0, 0, 0.1);
    position: fixed;
    z-index: 1000;
    bottom: 0px;
    width: 100%;
    height: 1.1733rem;
    background-color: #fff;
    display: flex;
    justify-content: space-between;

    a {
      flex: 1;
      text-align: center;
    }

    .nav {
      text-align: center;
      position: relative;
      line-height: normal;

      .iconfont {
        margin-top: 0.1333rem;
        font-size: 0.5333rem;
        color: #b1b1b1;
        display: inline-block;

        &.active {
          color: #f6a623;
        }
      }

      p {
        height: 0.5333rem;
        font-size: 0.32rem;
        color: #999;
        -webkit-transform-origin-x: center;
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
      }

      .message {
        background: red;
        min-width: 0.4rem;
        height: 0.4rem;
        line-height: 0.4rem;
        position: absolute;
        top: 0;
        right: 1.2rem;
        color: #fff;
        border-radius: 50%;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// footNav.vue?2ff6dc78